import React from 'react'
import QuoteDashboard from "./quote-dashboard";

const Quotes = ({}) => {
    return (
        <>
            <QuoteDashboard/>
        </>
    )
}

export default Quotes
